import { httpServices } from '../../../../apis'

export const reactivateAccountLocationBased = async () => {
  const response = await httpServices.billing.post(
    `/location-based/accounts/${httpServices.authInfo.accountId}/reactivate`
  )

  return response.data
}
